import NotificationsSettings from "./NotificationsSettings";

export default NotificationsSettings;